import _get from 'lodash/get';
import { useWatcherLink } from '@/processes/WatcherLink';
import { HashratesWidget } from '@/features/sha256/Hashrates';
import { SharesWidget } from '@/features/sha256/Shares';
import Stats from '@/features/sha256/Stats';
import {
  PayoutsWidget,
  // PayoutsChartWidget,
  PayoutsModal
} from '@/features/sha256/Payouts';
import { WorkersWidget, WorkersModal } from '@/features/sha256/Workers';

const Dashboard = () => {
  const { isWatcherLink } = useWatcherLink();
  return (
    <div className='inner'>
      <Stats className="mb-4 sm:mb-8"/>
      <HashratesWidget className="mb-6"/>
      <WorkersWidget className='mb-6'/>

      {isWatcherLink ? (
        <div className="mb-6">
          <SharesWidget className='h-full'/>
        </div>
      ) : (
        <div className="flex flex-col md:flex-row -mx-3">
          <div className="px-3 w-full md:w-1/2 xl:w-3/5 mb-6">
            <SharesWidget className='h-full'/>
          </div>
          <div className="px-3 w-full md:w-1/2 xl:w-2/5 mb-6">
            <PayoutsWidget className="h-full"/>
          </div>
        </div>
      )}

      <WorkersModal/>
      <PayoutsModal/>
    </div>
  );
}

export default Dashboard;
